import i18n from '@/i18n/i18n'
import ContactService from '@/services/admin/ContactService.js'
import { build_query, errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const namespaced = true

export const allowedFilters = ['created_between', 'by_full_name_phone_email', 'by_url', 'by_city', 'subject']
export const allowedSorts = '-created_at'

export const state = {
  contacts: [],
  meta: null
}

export const mutations = {
  SET_CONTACTS(state, contacts) {
    state.contacts = contacts.data
    state.meta = contacts.meta
  }
}

export const actions = {
  getContacts({ commit, dispatch }, query) {
    let newQuery = build_query(query, allowedFilters, allowedSorts)

    return new Promise((resolve, reject) => {
      ContactService.getContacts(newQuery)
        .then(response => {
          commit('SET_CONTACTS', response)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.contact.contact_requests')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  export({ dispatch }, query) {
    let newQuery = build_query(query, allowedFilters, allowedSorts)

    return new Promise((resolve, reject) => {
      ContactService.export(newQuery)
        .then(response => {
          const notification = {
            type: 'info',
            message: t('store.shared.exporting', {
              element: t('store.admin.contact.contact_requests')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.exporting_error', {
                element: t('store.admin.contact.contact_requests')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
